<template>
  <div class="container" :data-corp-id="corpId">
    <div class="welshop_banner">
      <a href="javascript:;"><img v-if="listBanner" :src="listBanner"/></a>
    </div>
    <div class="shopList">
      <h2>商品列表</h2>
      <ul class="prize-list">
        <li class="prizeList" v-for="listStore in listShop">
          <router-link class="enterDetail" :to="{ path: '/welfare/detail?goodsId='+ listStore.goodsId+'&goodsVoucherId='+listStore.goodsVoucherId+'&orderGoodsVoucherId='+listStore.orderGoodsVoucherId+'&welfareType='+listStore.welfareType}">
            <div class="shopImg">
              <img :src="listStore.cover"/>
              <div class="noShop" v-if="listStore.status==2">
                <p class="showShop">已领完</p>
              </div>
            </div>
            <p class="shop-desc"><span>{{listStore.title}}</span></p>
          </router-link>
        </li>
      </ul>
    </div>
    <home :ishome=0></home>
  </div>
</template>
<script>
import aghm from '../../api/aghm.js'
import home from '../common/home.vue'
import {
    mapGetters,
    mapActions
} from 'vuex'
export default {
  data () {
    return {
      listBanner:"",
      listShop:{

      }
    }
  },
  components:{
    home

  },
  computed:{   	 	 
  	 ...mapGetters({
      getUserInfo: 'getUserInfo',
    }),
    corpId(){
      return this.getUserInfo.corpId || '';
    },

  },
  watch:{

  },
  beforeDestroy() {
    // 组件销毁时恢复默认标题
    this.$store.commit('CORP_CUSTOMIZE_ATTR', {
      data: {
        key: 'page_title_default',
        value: ''
      }
    })
  },
  created(){
    let gid = this.$route.query.goodsVoucherId;
    let oid = this.$route.query.orderGoodsVoucherId;
    aghm.getPackageInfo({
      "goodsVoucherId":gid,
      "orderGoodsVoucherId":oid
    }
    ).then((res) =>{
      let data = res.data.body;
      this.listBanner = data.banner;
      this.listShop = data.list;
      this.$store.commit('CORP_CUSTOMIZE_ATTR', { 
        data: { 
          key: 'page_title_default', 
          value: data.name,
        } 
      })
  },(error) =>{
      console.log("error");
    })
  },
  methods:{

  },
  mounted(){}
}
</script>